<template>
  <div class="icons">
    <a
      id="fb-share"
      class="dark-ben-franklin mbm"
      :href="facebookHref"
      data-analytics="social" 
      target="_blank"
    >
      <i
        class="fab fa-facebook prs"
        aria-hidden="true"
      />
      <span class="desktop">Share on Facebook</span>
    </a>
    <a
      class="dark-ben-franklin mbm"
      :href="twitterHref"
      target="_blank"
    >
      <i
        class="fab fa-x-twitter prs"
        aria-hidden="true"
      />
      <span class="desktop">Share on Twitter</span>
    </a>
    <a
      class="dark-ben-franklin mbm"
      href="javascript:window.print()"
      data-analytics="social"
    >
      <i
        class="fas fa-print prs"
        aria-hidden="true"
      />
      <span class="desktop">Print this section</span>
    </a>
    <a
      class="dark-ben-franklin mbm"
      :href="emailHref"
      data-analytics="social"
    >
      <i
        class="fas fa-envelope prs"
        aria-hidden="true"
      />
      <span class="desktop">Email this section</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'IconSection',
  props: {
    documentTitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    facebookHref() {
      return 'http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href);
    },
    twitterHref() {
      return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(window.location.href);
    },
    emailHref() {
      return 'mailto:?subject=' + this.documentTitle + '&body=' + encodeURIComponent(window.location.href);
    },
  },
};
</script>